import "../../stylesheets/bootstrap/page/single_pages"
import bannerInit from "../../units/parallax-banner"

$(document).ready(function () {
  bannerInit()

  initSwiper();

  //click product
  $(".card_link").click(function (e) {
    //setting gtm click
    e.preventDefault();
    var _this = this
    let location = window.location.pathname
    dataLayer.push({
      'event': 'Product Click',
      'tag': $(this).find(".package_name").text(),
      'ecommerce': {
        'click': {
          'actionField': {
            'list': location.replace('/', "")
          },
          'products': [{
            'name': $(this).find(".package_name").text(),
            'id': $(this).find(".package_name").attr('name'),
            'brand': $(this).find(".ins_name").text(),
            'list': location.replace('/', "")
          }],
        },
      },
      'eventCallback': function () {
        window.location.href = $(_this).attr("href");
      }
    })
  })


  //for gtm impression
  var plans = []
  //get plan list for ga
  function add_plan() {
    let pathname = window.location.pathname
    $('.card').each(function (i, v) {
      console.log($($('.ins_name')[i]))
      plans.push({
        'name': $($('.package_name')[i]).text(),
        'id': $($('.package_name')[i]).attr('name'),
        'brand': $($('.ins_name')[i]).text(),
        'list': pathname.replace('/', "")
      })
    })
  }
  add_plan()
  //push dataLayer
  let pathname = window.location.pathname
  dataLayer.push({
    'event': 'Search',
    'tag': pathname.replace('/', ""),
    'ecommerce': {
      'currencyCode': 'TWD', // 貨幣
      'impressions': plans
    }
  });

});

function initSwiper() {


  let swiper = new Swiper('.infographics', {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.info-next',
      prevEl: '.info-prev',
    },
    breakpoints: { //rwd
      1920: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1196: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 10,
      }
    }
  });
}